//react
import React, { useState } from "react";
import { useParams } from "react-router-dom";

//material UI
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  RadioGroup,
} from "@mui/material";
import { Box } from "@mui/system";

//react redux
import { useDispatch, useSelector } from "react-redux";

//slices
import {
  // addAnalysisAndGraphs,
  setIsLoading,
} from "../../../features/datatable/dataTableSlice";

//functions
import { createAnalysis } from "../../../utils/computation/analysis";
import { getColumnValues } from "../../../utils/computation/getColumnValues";
import { getNormality } from "../../../utils/computation/getNormality";
import Dropdown from "../../Dropdown";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  p: 4,
  borderRadius: "15px",
};

const NormalityTestModal = ({ title, closeMenu, openModal, setOpenModal }) => {
  //local states
  const [Methods, setMethods] = useState({
    isShapiro: true,
    isKolmogorov: true,
    // isKendall: true,
    isAndersonDarling: true,
  });

  const [selectedColumn, setSelectedColumn] = useState("");
  const [graphs, setgraphs] = useState({
    isHistogram: true,
    // isProbability: false,
    // isKendall: false,
  });

  //dispatch
  const dispatch = useDispatch();

  //params
  const { documentId } = useParams();

  //redux states
  const { token } = useSelector((state) => state.auth);
  const { data } = useSelector((state) => state.dataTable);

  //functions

  const handleChange = (event) => {
    setSelectedColumn(event.target.value);
  };
  const handleGraphCBChange = (event) => {
    setgraphs({
      ...graphs,
      [event.target.name]: event.target.checked,
    });
  };
  const handleMethodsChange = (event) => {
    setMethods({ ...Methods, [event.target.name]: event.target.checked });
  };

  const computeTTest = async (col) => {
    dispatch(setIsLoading());
    // get the array value of selected column
    const value = getColumnValues(data, col);

    closeMenu();

    if (value.length > 0) {
      const result = await getNormality(value);
      if (!result) return;

      const normalityResults = {
        ...result,
        column: col,
        graphs,
        Methods,
        title,
      };

      // console.log({ normalityResults });

      try {
        // console.log("creating docs");
        // create analysis in subcollection
        const resFromCreateAnalysis = await createAnalysis(
          token,
          documentId,
          normalityResults
        );
        // console.log({ resFromCreateAnalysis });
        // normalityResults.id = resFromCreateAnalysis.id;
      } catch (error) {
        return console.log("error", error);
      }
      // dispatch(addAnalysisAndGraphs(normalityResults));
    }

    dispatch(setIsLoading());
  };

  return (
    <Modal
      open={openModal === title}
      onClose={closeMenu}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <h1> {title}</h1>
        <Grid
          item
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          style={{
            padding: "10px",
          }}
        >
          <Grid item xs={6} p={1}>
            <h3> Data Range</h3>
            <h3
              style={{
                marginTop: "10px",
              }}
            >
              Select a column for the test
            </h3>
            <FormControl variant="filled" fullWidth sx={{ mt: 1 }}>
              <InputLabel id="demo-simple-select-label">Column</InputLabel>
              <Dropdown value={selectedColumn} onChange={handleChange} />
            </FormControl>
          </Grid>

          <Grid item xs={6} p={1}>
            <h3> Graphs</h3>
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="Histogram"
                name="radio-buttons-group"
              >
                <FormControlLabel
                  value="Histogram"
                  control={
                    <Checkbox
                      checked
                      disabled
                      onChange={handleGraphCBChange}
                      name="isHistogram"
                    />
                  }
                  label="Histogram"
                />
                {/* <FormControlLabel
                    value="Probability plot"
                    control={
                      <Checkbox
                        onChange={handleGraphCBChange}
                        name="isProbability"
                      />
                    }
                    label="Probability plot"
                  />
                  <FormControlLabel
                    value="Kendall's tau"
                    control={
                      <Checkbox
                        onChange={handleGraphCBChange}
                        name="isKendall"
                      />
                    }
                    label="Kendall's tau"
                  /> */}
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={6} p={1}>
            <h3> Test methods for normality</h3>
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="Histogram"
                name="radio-buttons-group"
              >
                <FormControlLabel
                  value="Shapiro-Wilk Test"
                  control={
                    <Checkbox
                      checked
                      disabled
                      onChange={handleMethodsChange}
                      name="isShapiro"
                    />
                  }
                  label="Shapiro-Wilk Test"
                />
                <FormControlLabel
                  value="kolmogorov-smirnov Test"
                  control={
                    <Checkbox
                      checked
                      disabled
                      onChange={handleMethodsChange}
                      name="isKolmogorov"
                    />
                  }
                  label="Kolmogorov-Smirnov Test"
                />
                <FormControlLabel
                  value="Anderson Darling"
                  control={
                    <Checkbox
                      checked
                      disabled
                      onChange={handleMethodsChange}
                      name="isAndersonDarling"
                    />
                  }
                  label="Anderson-Darling"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>

        <div style={{ display: "flex", float: "right" }}>
          <Button
            variant="outlined"
            style={{
              borderRadius: "7px",
            }}
            onClick={closeMenu}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            style={{
              width: "auto",
              marginLeft: "10px",
              borderRadius: "7px",
            }}
            onClick={() => computeTTest(selectedColumn)}
          >
            Run Function
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default NormalityTestModal;
